<div class="fireworks-overlay" [class.visible]="visible" aria-hidden="true">
  <canvas #canvas></canvas>
  <div class="fireworks-banner" *ngIf="visible && label">{{ label }}</div>
</div>
